/* C.C.D. colour chips on product cards / index rows.
   Hover (mouse) previews that colour's variant image; click / tap / Enter picks it.
   A colour whose variant has no image (no data-src) leaves the image as it is. */
(function () {
  function imgOf(card) {
    return card.querySelector('.ccd-img-front, .th img, .ccd-frame > img');
  }
  function remember(img) {
    if (!img.dataset.o) {
      img.dataset.o = img.getAttribute('src') || '';
      img.dataset.os = img.getAttribute('srcset') || '';
    }
  }
  function show(card, chip) {
    var img = imgOf(card);
    if (!img || !chip || !chip.dataset.src) return false;
    remember(img);
    img.src = chip.dataset.src;
    if (chip.dataset.srcset) img.srcset = chip.dataset.srcset; else img.removeAttribute('srcset');
    card.classList.add('is-colorpick');
    return true;
  }
  function restore(card) {
    var picked = card.querySelector('.ccd-chip-btn[data-picked]');
    if (picked && show(card, picked)) return;
    var img = imgOf(card);
    if (img && img.dataset.o) {
      img.src = img.dataset.o;
      if (img.dataset.os) img.srcset = img.dataset.os; else img.removeAttribute('srcset');
    }
    card.classList.remove('is-colorpick');
  }
  function pick(card, chip) {
    card.querySelectorAll('.ccd-chip-btn').forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) c.setAttribute('data-picked', '1'); else c.removeAttribute('data-picked');
    });
    if (!show(card, chip)) restore(card);
  }
  function cardOf(chip) { return chip.closest('a') || chip.parentNode; }

  document.addEventListener('mouseover', function (e) {
    var chip = e.target.closest && e.target.closest('.ccd-chip-btn');
    if (chip) show(cardOf(chip), chip);
  });
  document.addEventListener('mouseout', function (e) {
    var chip = e.target.closest && e.target.closest('.ccd-chip-btn');
    if (chip && !chip.contains(e.relatedTarget)) restore(cardOf(chip));
  });
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.ccd-chip-btn');
    if (!chip) return;
    e.preventDefault();
    e.stopPropagation();
    pick(cardOf(chip), chip);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var chip = e.target.closest && e.target.closest('.ccd-chip-btn');
    if (!chip) return;
    e.preventDefault();
    pick(cardOf(chip), chip);
  });
})();
